define('models/forgotPasswordModel',[
    'models/base/baseModel',
    'helpers/skydropContextHelper',
],
function (BaseModel, contextHelper) {
    'use strict';
    return BaseModel.extend({
        url: function () {
            return contextHelper.getPasswordResetRequestUrl();
        },
        
        defaults: {},
        
        parse: function (response) {
            return response.length > 0 ? response[0] : response;
        }
    });
});
